import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, } from '@tyler-components-web/core';
import { QuantityFieldAdapter } from './quantity-field-adapter';
import { QuantityFieldFoundation } from './quantity-field-foundation';
import { QUANTITY_FIELD_CONSTANTS } from './quantity-field-constants';
import { IconButtonComponent } from '../icon-button';
var template = require('./quantity-field.html');
var styles = require('./quantity-field.css');
var QuantityFieldComponent = /** @class */ (function (_super) {
    __extends(QuantityFieldComponent, _super);
    function QuantityFieldComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, QUANTITY_FIELD_CONSTANTS.elementName, template, styles);
        _this._foundation = new QuantityFieldFoundation(new QuantityFieldAdapter(_this));
        return _this;
    }
    Object.defineProperty(QuantityFieldComponent, "observedAttributes", {
        get: function () {
            return [
                QUANTITY_FIELD_CONSTANTS.attributes.INVALID,
                QUANTITY_FIELD_CONSTANTS.attributes.REQUIRED,
            ];
        },
        enumerable: true,
        configurable: true
    });
    QuantityFieldComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'invalid');
        upgradeProperty(this, 'required');
    };
    QuantityFieldComponent.prototype.connectedCallback = function () {
        var _this = this;
        if (this._requiredElementsPresent()) {
            this._foundation.connect();
        }
        else {
            this._ensureElementsPresent().then(function () {
                _this._foundation.connect();
            });
        }
    };
    QuantityFieldComponent.prototype.disconnectedCallback = function () {
        this._foundation.disconnect();
    };
    QuantityFieldComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case QUANTITY_FIELD_CONSTANTS.attributes.INVALID:
                this.invalid = this.hasAttribute(QUANTITY_FIELD_CONSTANTS.attributes.INVALID);
                break;
            case QUANTITY_FIELD_CONSTANTS.attributes.REQUIRED:
                this.required = this.hasAttribute(QUANTITY_FIELD_CONSTANTS.attributes.REQUIRED);
                break;
        }
    };
    QuantityFieldComponent.prototype._ensureElementsPresent = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this._requiredElementsPresent()) {
                resolve();
                return;
            }
            var observer = new MutationObserver(function (changes) {
                var hasAddedNodes = changes.reduce(function (prev, curr) { return prev + curr.addedNodes.length; }, 0) > 0;
                if (hasAddedNodes) {
                    if (_this._requiredElementsPresent()) {
                        observer.disconnect();
                        resolve();
                    }
                }
            });
            observer.observe(_this, { childList: true, subtree: true });
        });
    };
    QuantityFieldComponent.prototype._requiredElementsPresent = function () {
        var inputElement = this.querySelector(QUANTITY_FIELD_CONSTANTS.selectors.INPUT);
        var decrementElement = this.querySelector(QUANTITY_FIELD_CONSTANTS.selectors.DECREMENT_BUTTON);
        var incrementElement = this.querySelector(QUANTITY_FIELD_CONSTANTS.selectors.INCREMENT_BUTTON);
        return !!inputElement && !!decrementElement && !!incrementElement;
    };
    Object.defineProperty(QuantityFieldComponent.prototype, "invalid", {
        /** Gets/sets the invalid state. */
        get: function () {
            return this._foundation.invalid;
        },
        set: function (value) {
            this._foundation.invalid = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuantityFieldComponent.prototype, "required", {
        /** Gets/sets the required state which controls the visibility of the asterisk in the label. */
        get: function () {
            return this._foundation.required;
        },
        set: function (value) {
            this._foundation.required = value;
        },
        enumerable: true,
        configurable: true
    });
    QuantityFieldComponent = __decorate([
        CustomElement({
            name: QUANTITY_FIELD_CONSTANTS.elementName,
            dependencies: [
                IconButtonComponent,
            ]
        })
    ], QuantityFieldComponent);
    return QuantityFieldComponent;
}(HTMLElement));
export { QuantityFieldComponent };
